<template>
  <div class="card card-modern pt-3" style="margin-top: 20px;">
    <div class="card-header card-header-tabs">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <span class="nav-tabs-title" style="font-weight: bold;">Estado de: {{estado.nome}}</span>
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="nav-item" v-for="(a, i) in acoes" :key="i">
              <a :class="'nav-link' + (acao == a.acao ? ' active show' : '')"
                 data-toggle="tab"
                 style="cursor: pointer"
                 @click="acao = a.acao">
                <i class="material-icons">{{ a.icone }}</i> {{ a.nome }}
                <div class="ripple-container"></div>
                <div class="ripple-container"></div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body">
      <TotaisEstado :estado_id="estado.id" :totaisEstadoInit="totaisEstado" v-if="acao == 'totaisEstado' && totaisEstado != null" ></TotaisEstado>
      <Difusao :difusaoinit="difusao" v-if="acao == 'difusao' && difusao != null" ></Difusao>

      <div style="display: flex; height: 300px" v-if="((acao == 'difusao' && difusao == null) || (acao == 'totaisEstado' && totaisEstado == null))">
        <div class="lds-spinner" style="margin: auto">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TotaisEstado from "./indicadores/TotaisEstado.vue";
import Difusao from "./indicadores/Difusao.vue";

export default {
  props: ["estadoini"],
  components: { TotaisEstado, Difusao },
  data() {
    return {
      acoes: [
        { nome: "Mapa", icone: "public", acao: "mapa" },
        { nome: "Totais do Estado", icone: "assessment", acao: "totaisEstado" },
        { nome: "Taxa de Difusão", icone: "show_chart", acao: "difusao" },
      ],
      acao: "totaisEstado",
      estado: this.estadoini,
      difusao: null,
      totaisEstado: null
    };
  },
  methods: {
    buscarTotaisEstado(estadoId = this.estado.id) {
      callAPI(
        "/estado/totais/" + estadoId,
        "GET",
        null,
        (totaisEstado) => {
          this.totaisEstado = totaisEstado;
        }
      );
    },
    buscarDifusao(estadoId = this.estado.id) {
      callAPI(
        "/estado/difusao/" + estadoId,
        "GET",
        null,
        (difusao) => {
          this.difusao = difusao;
        }
      );
    },
  },
  created() {
    this.buscarTotaisEstado();
    this.buscarDifusao();
  },
  watch: {
    acao(acao) {
      if (acao == "mapa") {
        this.$emit("mapa");
      }
    },
  },
};
</script>

<style scoped>
.card-header-tabs {
  background: transparent !important;
  box-shadow: none !important;
  margin-bottom: 20px;
  padding: 0 !important;
}
.nav-tabs-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.nav-tabs-wrapper .nav-tabs-title {
  color: #333;
  font-size: 1.2rem;
  margin-right: 20px;
}
.nav-tabs {
  border-bottom: none !important;
  display: flex;
  gap: 10px;
  background: transparent !important;
}
.nav-tabs .nav-link {
  border: none !important;
  border-radius: 30px !important;
  color: #666 !important;
  font-weight: 500;
  padding: 8px 16px !important;
  transition: all 0.3s ease;
  background-color: #f4f7f6 !important;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 !important;
}
.nav-tabs .nav-link:hover {
  background-color: #e2e8e5 !important;
  color: #333 !important;
}
.nav-tabs .nav-link.active {
  background-color: #ff9800 !important; /* Solar brand accent */
  color: #fff !important;
  box-shadow: 0 4px 10px rgba(255, 152, 0, 0.3) !important;
}
.nav-tabs .nav-link i.material-icons {
  font-size: 20px;
  margin: 0 !important;
}
</style>
